/**
 * Copyright 2021 mmmint.ai info@mmmint.ai - All Rights Reserved.
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 * Proprietary and confidential to MMM Intelligence UG (haftungsbeschränkt).
 */
/**
 * The keys of the settings for the crn setup
 */
export enum CrnSettingKeys {
  /**
   * The customer osa id for which the partner is requesting access.
   * This setting is partner specific
   * @example OsaId: xxxxxxxx-xxxx-xxxx-xxxx-xxxxxxxxxxx
   */
  CUSTOMER_OSA_ID = "CRN_CUSTOMER_OSA_ID",

  /**
   * The customer osa id for which the partner is requesting access.
   * This setting is partner specific
   * @example OsaId: xxxxxxxx-xxxx-xxxx-xxxx-xxxxxxxxxxx
   */
  EVENT_BUS_ID = "CRN_EVENT_BUS_ID",

  /**
   * Enable automatically export the "Schadensmeldung" to CRN.
   */
  AUTO_IMPORT = "CRN_AUTO_IMPORT"
}
